import { AsyncLocalStorage } from "node:async_hooks";
import type { Credentials } from "./credentials.js";

export interface RequestContext {
  path: string;
  ip: string | undefined;
  userId?: number;
  teamId?: number;
  viewerId?: string;
  activeToolName?: string;
  activeToolArgs?: Record<string, unknown>;
  activeToolStartedAt?: number;
}

const storage = new AsyncLocalStorage<RequestContext>();

export function runWithRequestContext<T>(
  context: RequestContext,
  callback: () => T,
): T {
  return storage.run(context, callback);
}

export function getRequestContext(): RequestContext | undefined {
  return storage.getStore();
}

export function setRequestUser(credentials: Credentials): void {
  const store = storage.getStore();
  if (!store) return;
  if (credentials.type === "client_token") return;

  if (credentials.userId !== undefined) store.userId = credentials.userId;
  if (credentials.viewerId !== undefined) store.viewerId = credentials.viewerId;
  if (credentials.teamId !== undefined) store.teamId = credentials.teamId;
}

export function setActiveTool(
  name: string,
  args: Record<string, unknown>,
): void {
  const store = storage.getStore();
  if (!store) return;
  store.activeToolName = name;
  store.activeToolArgs = args;
  store.activeToolStartedAt = Date.now();
}
